/* eslint-disable @next/next/no-img-element */
import React from "react";
import { useTheme } from "~app/providers/ThemeProvider";
import PrivacyDark from "../svgs/privacy/PrivacyDark";
import PrivacyLight from "../svgs/privacy/PrivacyLight";
import PrivacyGlossy from "../svgs/privacy/PrivacyGlossy";

const PrivacyHanger = () => {
  const { theme } = useTheme()!;
  let ChippyPromptImage;

  const PromptWindow98 = () => (
    <img width="100%" alt="Chippy privacy image" src="/privacy-window98.png" />
  );

  switch (theme) {
    case "dark":
      ChippyPromptImage = PrivacyDark;
      break;
    case "light":
      ChippyPromptImage = PrivacyLight;
      break;
    case "glossy":
      ChippyPromptImage = PrivacyGlossy;
      break;

    default:
      ChippyPromptImage = PromptWindow98;
      break;
  }

  return (
    <div className="desktop-only privacy-image">
      <ChippyPromptImage />
    </div>
  );
};

export default PrivacyHanger;
